/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import DeleteIcon from '@mui/icons-material/Delete';
import AttachmentIcon from '@mui/icons-material/Attachment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    TextField, MenuItem, Typography, Box, Button, Paper,
    Alert, Dialog, DialogActions, DialogContent, DialogTitle, Grid,
    IconButton, Snackbar, Stack, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Tabs, Tab, Checkbox, FormControlLabel, Tooltip,
    List, ListItem, ListItemButton, ListItemText, LinearProgress,
    FormControl, Select, InputLabel, Autocomplete
} from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import MuiAlert from '@mui/material/Alert';
import DocumentPicker from './DocumentPicker';
import React from 'react';
import { saveAs } from 'file-saver';


// --- Helper Functions for Form Components ---
const FormField = ({ labelEng, labelAfr, name, type = "text", value, onChange, isPreview, isMandatory = true, multiline = false, rows = 1, select = false, ...rest }) => {
    const inputProps = isPreview ? { readOnly: true } : {};
    const labelContent = (
        <>
            {isMandatory ? '*' : ''} {labelEng} / <span style={{ fontWeight: 'normal' }}>{labelAfr}</span>{isMandatory ? '*' : ''}
        </>
    );
    return (
        <TextField
            label={labelContent}
            fullWidth
            margin="normal"
            name={name}
            type={type}
            size="small"
            value={value}
            onChange={onChange}
            InputLabelProps={{ shrink: true }}
            InputProps={inputProps}
            disabled={isPreview}
            multiline={multiline}
            rows={rows}
            select={select}
            {...rest}
        >
            {/* children needed for select */}
            {rest.children}
        </TextField>
    );
};
// --- End Helper Functions ---

// 🛠️ NEW HELPER: Currency Adornment for the Fee field
const CurrencyAdornment = () => (
    <Typography variant="body1" sx={{ mr: 1, color: 'text.secondary' }}>R</Typography>
);


// Custom TabPanel component
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`accounts-tabpanel-${index}`}
            aria-labelledby={`accounts-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

// 🎯 NPA-SPECIFIC ACCOUNT OPTIONS (Draft & Final L&D) 🎯
export const NPA_ACCOUNT_OPTIONS = [
    { label: 'DRAFT ACCOUNTS' },
    { label: 'FINAL LIQUIDATION AND DISTRIBUTION' },
    { label: 'FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'AMENDED FINAL LIQUIDATION AND DISTRIBUTION' },
    { label: 'AMENDED FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'SUPPLEMENTARY FINAL LIQUIDATION AND DISTRIBUTION' },
    { label: 'SUPPLEMENTARY FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
];

// 🎯 DEFAULT COMPREHENSIVE ACCOUNT OPTIONS (Recreating original list) 🎯
const DEFAULT_ACCOUNT_OPTIONS = [
    { label: 'FIRST LIQUIDATION AND DISTRIBUTION' },
    { label: 'FIRST LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'AMENDED FIRST LIQUIDATION & DISTRIBUTION' },
    { label: 'AMENDED FIRST LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'FIRST & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'FIRST & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'AMENDED FIRST & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'AMENDED FIRST & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'SUPPLEMENTARY FIRST & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'SUPPLEMENTARY FIRST & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'FIRST & FINAL LIQUIDATION' },
    { label: 'FIRST & FINAL LIQUIDATION & CONTRIBUTION' },
    { label: 'AMENDED FIRST & FINAL LIQUIDATION' },
    { label: 'AMENDED FIRST & FINAL LIQUIDATION & CONTRIBUTION' },

    { label: 'SECOND LIQUIDATION AND DISTRIBUTION' },
    { label: 'SECOND LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'AMENDED SECOND LIQUIDATION & DISTRIBUTION' },
    { label: 'AMENDED SECOND LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'SECOND & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'SECOND & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'AMENDED SECOND & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'AMENDED SECOND & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'SUPPLEMENTARY SECOND & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'SUPPLEMENTARY SECOND & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'THIRD LIQUIDATION AND DISTRIBUTION' },
    { label: 'THIRD LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'AMENDED THIRD LIQUIDATION & DISTRIBUTION' },
    { label: 'AMENDED THIRD LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'THIRD & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'THIRD & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
    { label: 'AMENDED THIRD & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'AMENDED THIRD & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },

    { label: 'SUPPLEMENTARY THIRD & FINAL LIQUIDATION & DISTRIBUTION' },
    { label: 'SUPPLEMENTARY THIRD & FINAL LIQUIDATION, DISTRIBUTION & CONTRIBUTION' },
];


const AccountsTab = ({ matter }) => {
    const [tableData, setTableData] = useState([]);
    const [estateNos, setEstateNos] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isInvitedUser, setIsInvitedUser] = useState(false);
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({
        accountType: "",
        lodgedDate: "",
        confirmedDate: "",
        releaseDate: "",
        fee: "", 
        totalFees: "",
        iconInsolvencyFees: "",
        legalMatterId: "",
        draftedBy: "",
        querySheetDate: "",
        preliminaryRequirements: "",
        inspectionStartDate: "",
        inspectionEndDate: "",
        preConfirmationRequirements: "",
        form5Date: "",
        postConfirmationRequirements: "",
        destructionDate: "",
        form7Date: "",
        feesPaidStatus: "Unpaid", // New field
        invoiceNumber: "", // 🆕 New field
        invoiceAmount: "", // 🆕 New field
        ldAccountDocumentUrl: null, // 🆕 New field
        confirmationDocumentUrl: null, // 🆕 New field
        lieOpenPlace: "", // 🎯 6.1
        inspectionCertificateObtained: false, // 🎯 6.2
        inspectionCertificateDocumentUrl: null, // 🎯 6.2
        jointFeesAmount: "", // 🎯 6.4
        jointFeesInvoiceNumber: "", // 🎯 6.4
        jointFeesInvoiceDate: "", // 🎯 6.4
        jointFeesPaid: false, // 🎯 6.4
    });
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const theme = useTheme();

    // NEW Tab State
    const [selectedTab, setSelectedTab] = useState(0);

    // 🆕 Document Picker State
    const [docPickerOpen, setDocPickerOpen] = useState(false);
    const [docPickerTarget, setDocPickerTarget] = useState(null); // 'ldAccount' or 'confirmation'
    const [isPickerOpening, setIsPickerOpening] = useState(false); // 🎯 State to trigger picker opening

    // Helper to compare file paths consistently
    const normalize = (path) => path ? path.replace(/\\/g, '/').toLowerCase() : "";


    // Extract 'legalMatterId' and 'estateId' from props
    const legalMatterId = matter?.id || '';

    // 🛠️ NEW: Determine if the matter is NPA
    const isNPA = matter?.estateClassification === 'NPA';
    
    // 🛠️ NEW: Select the correct account options based on NPA status
    const currentAccountOptions = isNPA ? NPA_ACCOUNT_OPTIONS : DEFAULT_ACCOUNT_OPTIONS;


    // --- Handlers ---
    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const formatDate = (date) => {
        if (!date) return '';
        const formattedDate = new Date(date);
        return formattedDate.toISOString().split('T')[0];
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        // Correct way to handle date input rendering in MUI TextField type="date"
        try {
            return date.toISOString().split('T')[0];
        } catch (e) {
            return '';
        }
    };

    // 🎯 HELPER: Safely parse numbers to prevent .toString() crashes
    const getSafeNumber = (val) => {
        if (val == null || val === '') return 0;
        const num = parseFloat(String(val).replace(/,/g, ''));
        return isNaN(num) ? 0 : num;
    };

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const res = await axios.get('/api/user', { withCredentials: true });
                if (typeof res.data !== 'object' || res.data === null) {
                    setUser(null);
                    return;
                }
                if (!res.data.role) {
                    res.data.role = "guest";
                }
                setUser(res.data);
            } catch (err) {
                setUser(null);
            }
        };

        fetchUser();
    }, []);

    const fetchAccounts = async () => {
        try {
            let request = null;

            if (legalMatterId) {
                request = axios.get(`/api/accounts?legalMatterId=${legalMatterId}`);
            }

            if (request) {
                const response = await request;
                const accountsArray = response.data?.data ?? response.data ?? [];

                const formattedData = accountsArray;

                if (Array.isArray(formattedData) && formattedData.length > 0) {
                    setTableData(formattedData);
                } else {
                    setTableData([]);
                    setSnackbarMessage("No accounts found for the specified identifier.");
                    setSnackbarSeverity("warning");
                    setOpenSnackbar(true);
                }
            } else {
                setSnackbarMessage("Please provide a valid Legal Matter ID.");
                setSnackbarSeverity("warning");
                setOpenSnackbar(true);
            }
        } catch (error) {
            setSnackbarMessage("Error fetching accounts.");
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        }
    };

    useEffect(() => {
        if (legalMatterId) {
            fetchAccounts();
        }
    }, [legalMatterId]);

    // 🎯 FIX: This effect ensures the DocumentPicker opens *after* the formData state has been updated.
    useEffect(() => {
        if (isPickerOpening) {
            setDocPickerOpen(true);
            setIsPickerOpening(false); // Reset the trigger
        }
    }, [isPickerOpening]);


    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => {
            const newData = { ...prevData, [name]: value };
            
            // 🎯 Auto-populate L&D Inspection End Date (14 days from Start Date)
            if (name === 'inspectionStartDate' && value) {
                const startDate = new Date(value);
                if (!isNaN(startDate.getTime())) {
                    const endDate = new Date(startDate);
                    endDate.setDate(endDate.getDate() + 14);
                    newData.inspectionEndDate = endDate.toISOString().split('T')[0];
                }
            }
            
            return newData;
        });
    };

    const handleAdd = async () => {
        if (!legalMatterId || !formData.accountType) {
            setSnackbarMessage("Please select an Account Type.");
            setSnackbarSeverity("warning");
            setOpenSnackbar(true);
            return;
        }

        const newAccount = {
            ...formData,
            legalMatterId: legalMatterId, // 🎯 FIX: Ensure legalMatterId is passed
            totalFees: parseFloat(formData.totalFees) || 0, // Ensure it's a number
            iconInsolvencyFees: parseFloat(formData.iconInsolvencyFees) || 0,
            fee: parseFloat(formData.totalFees) || 0, // Use totalFees for consistency
            feesPaidStatus: formData.feesPaidStatus || 'Unpaid',
        };

        try {
            const response = await axios.post('/api/accounts', newAccount);
            setTableData([...tableData, response.data]);
            setSnackbarMessage("Account added successfully.");
            setSnackbarSeverity("success");
            setOpenSnackbar(true);
            resetForm();
        } catch (error) {
            setSnackbarMessage("Error adding account.");
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        }
    };


    const handleEdit = (row) => {
        setSelectedRow(row);
        const newFormData = {
            ...row,
            totalFees: row.totalFees ?? row.fee ?? "",
            iconInsolvencyFees: row.iconInsolvencyFees || "",
            fee: row.fee !== undefined ? row.fee : row.fees || "",
            legalMatterId: legalMatterId,
            feesPaidStatus: row.feesPaidStatus || "Unpaid",
            draftedBy: row.draftedBy || row.compiler || "",
        };
        setFormData(newFormData);
    };

    const handleSave = async () => {
        if (!selectedRow) return;

        try {
            const updatedAccount = {
                ...formData,
                totalFees: parseFloat(formData.totalFees) || 0, // Ensure it's a number
                iconInsolvencyFees: parseFloat(formData.iconInsolvencyFees) || 0,
                fee: parseFloat(formData.totalFees) || 0,
                feesPaidStatus: formData.feesPaidStatus,
            };

            await axios.put(`/api/accounts/${selectedRow.id}`, updatedAccount);
            fetchAccounts(); // Refresh data to ensure all new data structures are picked up
            setSnackbarMessage('Account updated successfully.');
            setSnackbarSeverity('success');
            setOpenSnackbar(true);
            resetForm();
        } catch (error) {
            setSnackbarMessage('Error updating account.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        }
    };

    const handleDelete = async () => {
        if (selectedRow && window.confirm("Are you sure you want to delete this account record?")) {
            try {
                await axios.delete(`/api/accounts/${selectedRow.id}`);
                setTableData(tableData.filter((row) => row.id !== selectedRow.id));
                resetForm();
                setSnackbarMessage('Account deleted successfully.');
                setSnackbarSeverity('success');
                setOpenSnackbar(true);
            } catch (error) {
                setSnackbarMessage('Error deleting account.');
                setSnackbarSeverity('error');
                setOpenSnackbar(true);
            }
        }
    };

    const resetForm = () => {
        setFormData({
            accountType: "",
            lodgedDate: "",
            confirmedDate: "",
            releaseDate: "",
            fee: "",
            totalFees: "",
            iconInsolvencyFees: "",
            legalMatterId: legalMatterId || "",
            draftedBy: "",
            querySheetDate: "",
            preliminaryRequirements: "",
            inspectionStartDate: "",
            inspectionEndDate: "",
            preConfirmationRequirements: "",
            form5Date: "",
            postConfirmationRequirements: "",
            destructionDate: "",
            form7Date: "",
            feesPaidStatus: "Unpaid",
            invoiceNumber: "",
            invoiceAmount: "",
            ldAccountDocumentUrl: null,
            confirmationDocumentUrl: null,
            lieOpenPlace: "",
            inspectionCertificateObtained: false,
            inspectionCertificateDocumentUrl: null,
            jointFeesAmount: "",
            jointFeesInvoiceNumber: "",
            jointFeesInvoiceDate: "",
            jointFeesPaid: false,
        });
        setSelectedRow(null);
    };

    const handleCancel = () => {
        resetForm();
    }

    const handleAction = () => {
        if (selectedRow) {
            handleSave();
        } else {
            handleAdd();
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setOpenSnackbar(false);
    };

    // --- Component Render ---
    return (
        <Grid container spacing={2}>
            {/* Tab Header */}
            <Grid item xs={12}>
                {/* Centering the Tabs component */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'center' }}>
                    <Tabs 
                        value={selectedTab} 
                        onChange={handleTabChange} 
                        aria-label="Account Forms Tabs" 
                        variant="scrollable" 
                        scrollButtons="auto"
                    >
                        <Tab label="L&D Accounts" />
                    </Tabs>
                </Box>
            </Grid>

            {/* Tab Panel 0: Accounts Table & Entry Form (Existing Content) */}
            <TabPanel value={selectedTab} index={0}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h6" align="center" sx={{ color: 'text.primary' }}>L&D Accounts Management</Typography>
                    </Grid>

                    {/* Account Fields Section */}
                    <Grid item xs={12}>
                        <Paper elevation={3} sx={{ padding: 3, borderRadius: 2 }}>
                            <Typography variant="subtitle1" gutterBottom>
                                {selectedRow ? `Editing L&D Account ID: ${selectedRow.id}` : 'Add New L&D Account Record'}
                            </Typography>
                            <Grid container spacing={2}>
                                {/* Drafted By */}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Drafted By"
                                        name="draftedBy"
                                        value={formData.draftedBy || ""}
                                        variant="outlined"
                                        onChange={handleChange}
                                        disabled={user?.role === 'guest'}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Autocomplete
                                        freeSolo
                                        options={currentAccountOptions.map(opt => opt.label)}
                                        value={formData.accountType || ''}
                                        onChange={(e, newValue) => handleChange({ target: { name: 'accountType', value: newValue || '' } })}
                                        onInputChange={(e, newInputValue) => handleChange({ target: { name: 'accountType', value: newInputValue || '' } })}
                                        disabled={user?.role === 'guest'}
                                        renderInput={(params) => (
                                            <TextField 
                                                {...params} 
                                                label="Account Type*" 
                                                variant="outlined" 
                                                fullWidth 
                                            />
                                        )}
                                    />
                                </Grid>

                                {/* Date Submitted (Lodged) */}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Date Account Submitted"
                                        name="lodgedDate"
                                        type="date"
                                        value={formatDateForInput(formData.lodgedDate)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* Query Sheet Date */}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Query Sheet Date"
                                        name="querySheetDate"
                                        type="date"
                                        value={formatDateForInput(formData.querySheetDate)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* Preliminary Requirements */}
                                <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <TextField
                                        fullWidth
                                        label="Preliminary Requirements"
                                        name="preliminaryRequirements"
                                        type={formData.preliminaryRequirements === 'Not Applicable' ? 'text' : 'date'}
                                        value={formData.preliminaryRequirements === 'Not Applicable' ? 'Not Applicable' : formatDateForInput(formData.preliminaryRequirements)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest' || formData.preliminaryRequirements === 'Not Applicable'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={formData.preliminaryRequirements === 'Not Applicable'}
                                                onChange={(e) => handleChange({ target: { name: 'preliminaryRequirements', value: e.target.checked ? 'Not Applicable' : '' } })}
                                                name="preliminaryRequirementsNA"
                                                size="small"
                                                disabled={user?.role === 'guest'}
                                            />
                                        }
                                        label={<Typography variant="caption">N/A</Typography>}
                                    />
                                </Grid>

                                {/* L&D Inspection Start */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="L&D Inspection Start Date"
                                        name="inspectionStartDate"
                                        type="date"
                                        value={formatDateForInput(formData.inspectionStartDate)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* L&D Inspection End */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="L&D Inspection End Date"
                                        name="inspectionEndDate"
                                        type="date"
                                        value={formatDateForInput(formData.inspectionEndDate)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* Pre-Confirmation Requirements */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Pre-Confirmation Req Date"
                                        name="preConfirmationRequirements"
                                        type="date"
                                        value={formatDateForInput(formData.preConfirmationRequirements)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* Confirmation Date */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Confirmed Date"
                                        name="confirmedDate"
                                        type="date"
                                        value={formatDateForInput(formData.confirmedDate)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* Form 5 Date */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Form 5 Date"
                                        name="form5Date"
                                        type="date"
                                        value={formatDateForInput(formData.form5Date)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* Post Confirmation Requirements */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Post-Confirmation Req Date"
                                        name="postConfirmationRequirements"
                                        type="date"
                                        value={formatDateForInput(formData.postConfirmationRequirements)}
                                        variant="outlined"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                        disabled={user?.role === 'guest'}
                                        inputProps={{ max: '9999-12-31' }}
                                    />
                                </Grid>

                                {/* Total Fees */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Total Fees Amount"
                                        name="totalFees"
                                        type="number"
                                        value={formData.totalFees || ""}
                                        variant="outlined"
                                        onChange={handleChange}
                                        disabled={user?.role === 'guest'}
                                        InputProps={{
                                            startAdornment: <CurrencyAdornment />,
                                        }}
                                    />
                                </Grid>
                                
                                {/* Icon Insolvency Fees */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Icon Insolvency Fees"
                                        name="iconInsolvencyFees"
                                        type="number"
                                        value={formData.iconInsolvencyFees || ""}
                                        variant="outlined"
                                        onChange={handleChange}
                                        disabled={user?.role === 'guest'}
                                        InputProps={{
                                            startAdornment: <CurrencyAdornment />,
                                        }}
                                    />
                                </Grid>

                                {/* Fees Paid Status */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        select
                                        fullWidth
                                        label="Fees Paid Status"
                                        name="feesPaidStatus"
                                        value={formData.feesPaidStatus || 'Unpaid'}
                                        variant="outlined"
                                        onChange={handleChange}
                                        disabled={user?.role === 'guest'}
                                    >
                                        <MenuItem value="Paid">Paid</MenuItem>
                                        <MenuItem value="Unpaid">Unpaid</MenuItem>
                                    </TextField>
                                </Grid>

                                {/* Invoice Number */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Invoice Number"
                                        name="invoiceNumber"
                                        value={formData.invoiceNumber || ""}
                                        variant="outlined"
                                        onChange={handleChange}
                                        disabled={user?.role === 'guest'}
                                    />
                                </Grid>

                                {/* Invoice Amount */}
                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        label="Invoice Amount"
                                        name="invoiceAmount"
                                        type="number"
                                        value={formData.invoiceAmount || ""}
                                        variant="outlined"
                                        onChange={handleChange}
                                        disabled={user?.role === 'guest'}
                                        InputProps={{
                                            startAdornment: <CurrencyAdornment />,
                                        }}
                                    />
                                </Grid>

                                {/* Document Attachment Buttons */}
                                <Grid item xs={12} sm={6}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        startIcon={<AttachmentIcon />}
                                        onClick={() => { setDocPickerTarget('ldAccount'); setDocPickerOpen(true); }}
                                        disabled={user?.role === 'guest'}
                                        color={formData.ldAccountDocumentUrl ? "success" : "primary"}
                                    >
                                        {formData.ldAccountDocumentUrl ? 'L&D Account Attached' : 'Attach L&D Account'}
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        startIcon={<VisibilityIcon />}
                                        onClick={() => { setDocPickerTarget('confirmation'); setDocPickerOpen(true); }}
                                        disabled={user?.role === 'guest'}
                                        color={formData.confirmationDocumentUrl ? "success" : "primary"}
                                    >
                                        {formData.confirmationDocumentUrl ? 'Confirmation Attached' : 'Attach Confirmation'}
                                    </Button>
                                </Grid>

                                {/* 🎯 6.1: Place Where the L&D Account Will Lie Open */}
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Place Where L&D Account Will Lie Open"
                                        name="lieOpenPlace"
                                        value={formData.lieOpenPlace || ""}
                                        variant="outlined"
                                        onChange={handleChange}
                                        disabled={user?.role === 'guest'}
                                        placeholder="e.g. Master's Office, Bloemfontein"
                                    />
                                </Grid>

                                {/* 🎯 6.2: Inspection Certificate */}
                                <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={!!formData.inspectionCertificateObtained}
                                                onChange={(e) => handleChange({ target: { name: 'inspectionCertificateObtained', value: e.target.checked } })}
                                                name="inspectionCertificateObtained"
                                                disabled={user?.role === 'guest'}
                                            />
                                        }
                                        label="Inspection Certificate Obtained"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        startIcon={formData.inspectionCertificateDocumentUrl ? <VisibilityIcon /> : <AttachmentIcon />}
                                        onClick={() => { setDocPickerTarget('inspectionCertificate'); setDocPickerOpen(true); }}
                                        disabled={user?.role === 'guest'}
                                        color={formData.inspectionCertificateDocumentUrl ? "success" : "primary"}
                                    >
                                        {formData.inspectionCertificateDocumentUrl ? 'Certificate Attached' : 'Link Certificate'}
                                    </Button>
                                </Grid>

                                {/* 🎯 6.4: Joint Fees */}
                                <Grid item xs={12}>
                                    <Paper
                                        variant="outlined"
                                        sx={{
                                            p: 2,
                                            bgcolor: formData.jointFeesPaid ? '#e8f5e9' : '#fafafa',
                                            borderColor: formData.jointFeesPaid ? 'success.main' : undefined,
                                        }}
                                    >
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5 }}>Joint Fees</Typography>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    fullWidth
                                                    label="Amount of Joint Fees"
                                                    name="jointFeesAmount"
                                                    type="number"
                                                    value={formData.jointFeesAmount || ""}
                                                    variant="outlined"
                                                    onChange={handleChange}
                                                    disabled={user?.role === 'guest'}
                                                    InputProps={{ startAdornment: <CurrencyAdornment /> }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    fullWidth
                                                    label="Invoice Number"
                                                    name="jointFeesInvoiceNumber"
                                                    value={formData.jointFeesInvoiceNumber || ""}
                                                    variant="outlined"
                                                    onChange={handleChange}
                                                    disabled={user?.role === 'guest'}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    fullWidth
                                                    label="Date of Invoice / Payment"
                                                    name="jointFeesInvoiceDate"
                                                    type="date"
                                                    value={formatDateForInput(formData.jointFeesInvoiceDate)}
                                                    variant="outlined"
                                                    onChange={handleChange}
                                                    InputLabelProps={{ shrink: true }}
                                                    disabled={user?.role === 'guest'}
                                                    inputProps={{ max: '9999-12-31' }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={!!formData.jointFeesPaid}
                                                            onChange={(e) => handleChange({ target: { name: 'jointFeesPaid', value: e.target.checked } })}
                                                            name="jointFeesPaid"
                                                            disabled={user?.role === 'guest'}
                                                        />
                                                    }
                                                    label={
                                                        <Typography sx={{ fontWeight: 'bold', color: formData.jointFeesPaid ? 'success.main' : 'text.primary' }}>
                                                            {formData.jointFeesPaid ? 'Joint Fees Paid ✓' : 'Joint Fees Paid?'}
                                                        </Typography>
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>


                                {/* CONDITIONAL FINAL FIELDS */}
                                {(formData.accountType || '').toUpperCase().includes('FINAL') && (
                                    <>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                label="Release Date"
                                                name="releaseDate"
                                                type="date"
                                                value={formatDateForInput(formData.releaseDate)}
                                                variant="outlined"
                                                onChange={handleChange}
                                                InputLabelProps={{ shrink: true }}
                                            disabled={user?.role === 'guest'}
                                            inputProps={{ max: '9999-12-31' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                label="Form 7 Date"
                                                name="form7Date"
                                                type="date"
                                                value={formatDateForInput(formData.form7Date)}
                                                variant="outlined"
                                                onChange={handleChange}
                                                InputLabelProps={{ shrink: true }}
                                            disabled={user?.role === 'guest'}
                                            inputProps={{ max: '9999-12-31' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                fullWidth
                                                label="Destruction Date"
                                                name="destructionDate"
                                                type="date"
                                                value={formatDateForInput(formData.destructionDate)}
                                                variant="outlined"
                                                onChange={handleChange}
                                                InputLabelProps={{ shrink: true }}
                                            disabled={user?.role === 'guest'}
                                            inputProps={{ max: '9999-12-31' }}
                                            />
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* Buttons Section (Unified Actions) */}
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="flex-start" gap={2} sx={{ mt: 1 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleAction}
                            disabled={user?.role === 'guest'}
                                size="small"
                            >
                                {selectedRow ? 'Update L&D Account' : 'Add New L&D Account'}
                            </Button>
                            
                            <Button 
                                variant="outlined" 
                                onClick={handleCancel} 
                            disabled={user?.role === 'guest'}
                                size="small"
                            >
                                Reset / Cancel Edit
                            </Button>

                            {selectedRow && (
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={handleDelete}
                                disabled={user?.role === 'guest'}
                                    startIcon={<DeleteIcon />}
                                    size="small"
                                >
                                    Delete
                                </Button>
                            )}
                        </Box>
                    </Grid>


                    {/* Table Section */}
                    <Grid item xs={12}>
                        <Paper
                            elevation={3}
                            sx={{
                                padding: 2,
                                borderRadius: 2,
                                bgcolor: theme.palette.background.paper,
                                // The table below is wider than most screens (18 columns) - without this,
                                // its intrinsic width stretches this Paper (and the whole page) wider
                                // instead of scrolling inside TableContainer's own scrollbar.
                                overflow: 'hidden',
                            }}
                        >
                            <TableContainer sx={{ maxHeight: 600, overflowX: 'auto' }}>
                                <Table stickyHeader size="small">
                                    <TableHead>
                                        <TableRow sx={{ bgcolor: theme.palette.grey[100] }}>
                                            {[
                                                'Docs', 'Drafted By', 'Account Type', 'Date Submitted', 'Query Sheet', 'Insp. Start',
                                                'Insp. End', 'Confirmation', 'Form 5', 'Total Fees', 'Icon Fees', 'Fees Paid',
                                                'Lie Open Place', 'Insp. Cert.', 'Joint Fees', 'Release', 'Form 7', 'Destruction'
                                            ].map((header) => (
                                                <TableCell 
                                                    key={header} 
                                                    sx={{ 
                                                        color: theme.palette.text.secondary, 
                                                        fontWeight: 'bold',
                                                        minWidth: header.includes('Date') ? 120 : 150
                                                    }}
                                                >
                                                    {header}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableData.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={18} align="center" sx={{ color: theme.palette.text.secondary, py: 3 }}>
                                                    No accounts available.
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            tableData.map((row, index) => {
                                                const totalFeesNum = getSafeNumber(row.totalFees ?? row.fee);
                                                const iconFeesNum = getSafeNumber(row.iconInsolvencyFees);
                                                const safeAccountType = String(row.accountType || '').toUpperCase();
                                                
                                                return (
                                                <TableRow
                                                    key={row.id || index}
                                                    onClick={() => handleEdit(row)}
                                                    sx={{
                                                        cursor: 'pointer',
                                                        transition: 'background-color 0.2s',
                                                        bgcolor:
                                                            selectedRow?.id === row.id ? theme.palette.action.selected : (index % 2 === 0 ? theme.palette.background.paper : theme.palette.grey[50]),
                                                        '&:hover': {
                                                            bgcolor: theme.palette.action.hover,
                                                        },
                                                    }}
                                                >
                                                    <TableCell>
                                                        <Stack direction="row" spacing={0.5}>
                                                            <Tooltip title="View L&D Account Document">
                                                                <IconButton size="small" disabled={!row.ldAccountDocumentUrl} onClick={(e) => { e.stopPropagation(); setDocPickerTarget('ldAccount'); handleEdit(row); setIsPickerOpening(true); }}>
                                                                    <AttachmentIcon fontSize="inherit" color={row.ldAccountDocumentUrl ? 'primary' : 'disabled'} />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="View Confirmation Document">
                                                                <IconButton size="small" disabled={!row.confirmationDocumentUrl} onClick={(e) => { e.stopPropagation(); setDocPickerTarget('confirmation'); handleEdit(row); setIsPickerOpening(true); }}>
                                                                    <VisibilityIcon fontSize="inherit" color={row.confirmationDocumentUrl ? 'secondary' : 'disabled'} />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="View Inspection Certificate">
                                                                <IconButton size="small" disabled={!row.inspectionCertificateDocumentUrl} onClick={(e) => { e.stopPropagation(); setDocPickerTarget('inspectionCertificate'); handleEdit(row); setIsPickerOpening(true); }}>
                                                                    <AttachmentIcon fontSize="inherit" color={row.inspectionCertificateDocumentUrl ? 'success' : 'disabled'} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Stack>
                                                    </TableCell>
                                                    <TableCell>{row.draftedBy || row.compiler || 'N/A'}</TableCell>
                                                    <TableCell>{row.accountType || ''}</TableCell>
                                                    <TableCell>{formatDateForInput(row.lodgedDate)}</TableCell>
                                                    <TableCell>{formatDateForInput(row.querySheetDate)}</TableCell>
                                                    <TableCell>{formatDateForInput(row.inspectionStartDate)}</TableCell>
                                                    <TableCell>{formatDateForInput(row.inspectionEndDate)}</TableCell>
                                                    <TableCell>{formatDateForInput(row.confirmedDate)}</TableCell>
                                                    <TableCell>{formatDateForInput(row.form5Date)}</TableCell>

                                                    {/* Total Fees in Table */}
                                                    <TableCell>
                                                        <Typography
                                                            sx={{
                                                                color: totalFeesNum < 0 ? theme.palette.error.main : theme.palette.text.primary,
                                                                fontWeight: totalFeesNum < 0 ? 'bold' : 'normal',
                                                            }}
                                                        >
                                                            R {totalFeesNum.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </Typography>
                                                    </TableCell>
                                                    
                                                    {/* Icon Fees in Table */}
                                                    <TableCell>
                                                        <Typography
                                                            sx={{
                                                                color: iconFeesNum < 0 ? theme.palette.error.main : theme.palette.text.primary,
                                                                fontWeight: iconFeesNum < 0 ? 'bold' : 'normal',
                                                            }}
                                                        >
                                                            R {iconFeesNum.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </Typography>
                                                    </TableCell>

                                                    {/* Fees Paid Status in Table */}
                                                    <TableCell>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: row.feesPaidStatus === 'Paid' ? 'success.main' : 'error.main' }}>
                                                            {row.feesPaidStatus || 'Unpaid'}
                                                        </Typography>
                                                    </TableCell>

                                                    {/* 🎯 6.1: Lie Open Place */}
                                                    <TableCell>{row.lieOpenPlace || '-'}</TableCell>

                                                    {/* 🎯 6.2: Inspection Certificate status */}
                                                    <TableCell>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: row.inspectionCertificateObtained ? 'success.main' : 'error.main' }}>
                                                            {row.inspectionCertificateObtained ? 'Obtained' : 'Outstanding'}
                                                        </Typography>
                                                    </TableCell>

                                                    {/* 🎯 6.4: Joint Fees status */}
                                                    <TableCell>
                                                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: row.jointFeesPaid ? 'success.main' : 'error.main' }}>
                                                            {row.jointFeesPaid ? 'Paid' : (getSafeNumber(row.jointFeesAmount) > 0 ? 'Unpaid' : '-')}
                                                        </Typography>
                                                    </TableCell>
                                                    {/* Final Account Columns */}
                                                <TableCell>{safeAccountType.includes('FINAL') ? formatDateForInput(row.releaseDate) : '-'}</TableCell>
                                                <TableCell>{safeAccountType.includes('FINAL') ? formatDateForInput(row.form7Date) : '-'}</TableCell>
                                                <TableCell>{safeAccountType.includes('FINAL') ? formatDateForInput(row.destructionDate) : '-'}</TableCell>
                                                </TableRow>
                                            )})
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>
                </Grid>
            </TabPanel>

            {/* 🆕 Document Picker Modal */}
            <DocumentPicker
                open={docPickerOpen}
                onClose={() => setDocPickerOpen(false)}
                matterId={legalMatterId}
                user={user}
                onDocumentSelect={(filepath) => {
                    const fieldMap = { ldAccount: 'ldAccountDocumentUrl', confirmation: 'confirmationDocumentUrl', inspectionCertificate: 'inspectionCertificateDocumentUrl' };
                    setFormData(prev => ({ ...prev, [fieldMap[docPickerTarget] || 'ldAccountDocumentUrl']: filepath }));
                    setDocPickerOpen(false);
                }}
                onDocumentDelete={(deletedFilepath) => {
                    // When a document is deleted from the picker, clear the corresponding field in the form
                    if (normalize(formData.ldAccountDocumentUrl) === normalize(deletedFilepath)) {
                        setFormData(prev => ({ ...prev, ldAccountDocumentUrl: null }));
                    }
                    if (normalize(formData.confirmationDocumentUrl) === normalize(deletedFilepath)) {
                        setFormData(prev => ({ ...prev, confirmationDocumentUrl: null }));
                    }
                    if (normalize(formData.inspectionCertificateDocumentUrl) === normalize(deletedFilepath)) {
                        setFormData(prev => ({ ...prev, inspectionCertificateDocumentUrl: null }));
                    }
                }}
                folder="L&D Account"
                activeDocPath={
                    docPickerTarget === 'ldAccount' ? formData.ldAccountDocumentUrl
                        : docPickerTarget === 'inspectionCertificate' ? formData.inspectionCertificateDocumentUrl
                            : formData.confirmationDocumentUrl
                }
            />


            {/* Snackbar */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <MuiAlert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </MuiAlert>
            </Snackbar>
        </Grid>
    );
};

export default AccountsTab